module.exports = __webpack_public_path__ + "media/images/frontend/Ines_and_Horst_Zimmermann-cdde7f0c5e2dbb70ecd65d42172f3fac.png";